<template>
    <fieldset :disabled="!isEditing.value">
        <div class="title bg-success">Instrução</div>

        <div class="col-md-6">
            <label for="nome" class="col-form-label">Nome</label>
            <input v-model="instruction.name" id="nome" class="form-control">
        </div>

        <div class="col-md-6">
            <label for="descricao" class="col-form-label">Link</label>
            <input v-model="instruction.link" id="descricao" placeholder="https://www.site.com.br" class="form-control">
        </div>

        <button v-if="isEditing.value" type="button" class="actions btn btn-primary btn-sm" @click="saveInstruction">
            Salvar
        </button>
    </fieldset>

    <fieldset>
        <div class="title subtitle">Pontos</div>

        <SelectTriggers v-if="this.instruction?.company?.id && isEditing.value" :pointInit="point"
            :company_id="this.instruction.company.id" @update:point="addPoint" :show_all_hosts="true">
        </SelectTriggers>

        <table class="table table-sm">
            <thead class="table-light">
                <tr>
                    <th scope="col" class="col-id">ID</th>
                    <th scope="col" class="col-name">Host</th>
                    <th scope="col" class="col-link">Item</th>
                    <th scope="col" class="col-actions">Trigger</th>
                    <th v-if="isEditing.value" scope="col" class="col-actions">Ação</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="point in instruction.points" :key="point.id">
                    <td style="vertical-align: middle;">{{ point.id }}</td>
                    <td style="vertical-align: middle;">{{ point.hostId }}</td>
                    <td style="vertical-align: middle;">{{ point.itemId }}</td>
                    <td style="vertical-align: middle;">{{ point.triggerId }}</td>
                    <td class="text-center" style="vertical-align: middle;">
                        <div class="d-flex gap-1">
                            <a v-if="isEditing.value" @click="point.isDeleting = true" type="button"
                                class="actions btn btn-danger btn-sm">Excluir</a>
                            <ModalContent :is-modal-open="point.isDeleting" @close="() => point.isDeleting = false" @send="() => {
                                deletePoint(point.id);
                                point.isDeleting = false
                            }" :title="`Excluir essa trigger ?`">Você tem certeza que deseja excluir essa configuração de trigger ?
                            </ModalContent>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </fieldset>
</template>

<script>
import ModalContent from "@/components/ModalContent.vue";
import SelectTriggers from "@/components/SelectTriggers.vue";
import useEditMode from "@/services/EditingService";
import { instructionService, PointService } from "@/services/backend/ApiService";

export default {
    components: {
        SelectTriggers,
        ModalContent
    },
    data() {
        return {
            instruction: {},
            point: {}
        };
    },
    setup() {
        const isEditing = useEditMode();

        return { isEditing };
    },
    methods: {
        async loadInstructionData(id) {
            try {
                this.instruction = await instructionService.findOne(id);
            } catch (error) {
                console.error("Erro ao carregar os dados da instrução:", error);
            }
        },
        async saveInstruction() {
            this.instruction = await instructionService.update(this.instruction.id, this.instruction);
        },
        async addPoint(value) {
            this.point = { 
                ...value, 
                instruction: {
                    id: this.instruction.id 
                },
                company: {
                    id: this.instruction.company.id
                }
            }

            if (this.point.triggerId) {
                await PointService.create(this.point);
                this.instruction.points.push(this.point);
            }
        },
        async deletePoint(id) {
            await PointService.delete(id);
            this.instruction.points = this.instruction.points.filter((value) => value.id != id);
        }
    },
    mounted() {
        const instructionId = this.$route.params.id;

        if (instructionId) {
            this.loadInstructionData(instructionId);
        }
    }
};
</script>

<style scoped>
select {
    margin-bottom: 30px;
}

option[disabled] {
    background: rgb(221, 221, 221);
}
</style>
